import { removeToken } from "@/utils/token";
import Cookies from "js-cookie";

/**
 * Clears the current session: removes the access/refresh tokens (and Axios auth
 * headers, via `removeToken`) plus all account metadata cookies.
 *
 * Lives in its own module (instead of `@/utils/api`) so `redirectToLogin` can
 * use it without pulling the Axios instances into an import cycle.
 */
export const logout = () => {
  removeToken();
  Cookies.remove("userId");
  Cookies.remove("matchId");
  Cookies.remove("email");
  Cookies.remove("matchLicenseNumber");
  Cookies.remove("isMatchUser");
};
